// Modal dialogs: confirmations, warnings, the shared template modal.
//
// ONE dialog at a time. Simultaneous alerts (izključitev + brez kapetana + …)
// used to stack on screen, offset below each other — off the bottom on zoomed
// or small screens. Now they queue: the next one starts appearing the moment
// the current one begins to close, so nothing is ever hidden behind or below
// anything, and every dialog opens at the top of the screen.


global.alerts = {
  defaults: {
    yesLabel: 'DA',
    noLabel: 'NE',
    continueLabel: 'NADALJUJ',
    type: 'warning'
  },
  queue: [],
  // Dialogs that are on screen, by key. A keyed dialog is raised once: the
  // captain demand is re-asserted on every refused entry, and without this the
  // same question would stack a second copy behind the first — which nothing can
  // close, because that dialog has no dismiss of its own.
  activeKeys: {},
  addToQueue: function(data) {
    if(data.key && (alerts.activeKeys[data.key] || alerts.queue.some(function(d) { return d.key === data.key; }))) {
      return;
    }

    alerts.queue.push(data);
    if(alerts.queue.length == 1) {
      alerts.executeFromQueue();
    }
  },
  executeFromQueue: function() {
    if(alerts.queue.length === 0) return;
    var data = alerts.queue[0];
    alerts.show(data);
  },
  info: function(title, body) {
    alerts.addToQueue({ title: title, body: body, type: 'info' });
  },
  warning: function(body, opts) {
    alerts.addToQueue($.extend({ title: "POZOR!", body: body, type: "warning" }, opts || {}));
  },
  success: function(title, body) {
    alerts.addToQueue({ title: title, body: body, type: "success", yesCallback: null, noCallback: null });
  },
  confirmation: function(data) {
    alerts.addToQueue(data);
  },
  // data = { title, body, type, yesCallback, noCallback, continueCallback, yesLabel, noLabel, continueLabel, onShowCallback }
  show: function(data) {
    data = $.extend({}, alerts.defaults, data);
    var id = "modal-" + new Date().getTime();

    var $modal = $($('#template-modal-holder').html());
    $modal.prop('id', id);
    $modal.addClass('alerts-modal');
    // a caller may need a wider dialog than the default 500px — the prematch line-up
    // check reads two teams side by side
    if(data.modalClass) $modal.addClass(data.modalClass);

    var $title = $modal.find('.modal-header');
    $title.addClass('alert-'+data.type);
    $title.find('.modal-title').html(data.title);

    var $body = $modal.find('.modal-body');
    $body.html(data.body);

    if(data.yesCallback || data.noCallback) {
      var yesSelector = "#modal-yes-btn";
      $modal.find(yesSelector).text(data.yesLabel);
      $modal.find(yesSelector).parent().removeClass('hide');
      $(document).on('click', '#' + id + " " + yesSelector, function() {
        if(data.yesCallback) {
          data.yesCallback();  
        }
        $modal.modal('hide');
      });

      var noSelector = "#modal-no-btn";
      $modal.find(noSelector).text(data.noLabel);
      $modal.find(noSelector).parent().removeClass('hide');
      $(document).on('click', '#' + id + " " + noSelector, function() {
        if(data.noCallback) {
          data.noCallback();  
        }
        $modal.modal('hide');
      });
    } else if(data.continueCallback) {
      var continueSelector = "#modal-continue-btn";
      $modal.find(continueSelector).text(data.continueLabel);
      $modal.find(continueSelector).parent().removeClass('hide');
      $(document).on('click', '#' + id + " " + continueSelector, function() {
        if(data.continueCallback) {
          data.continueCallback();  
        }
        $modal.modal('hide');
      });
    } else if(data.dismissible === false) {
      // A dialog that demands a choice: no continue button, no ×, no escape and no
      // click-away. The only way out is one of the choices in the body, which is
      // the point — the captain has to be named before the sheet goes on.
      $modal.find('.close').remove();
      $modal.find('.modal-footer').remove();
    } else {
      // Ticket 2 (CLAUDE-TODO): no callbacks used to mean no footer, so ten warnings
      // — "player is ejected" among them — could only be closed by the 14px ×. The
      // continue button dismisses by itself and needs no callback to exist.
      var closeSelector = "#modal-continue-btn";
      $modal.find(closeSelector).text(data.continueLabel);
      $modal.find(closeSelector).parent().removeClass('hide');
    }

    if(data.key) alerts.activeKeys[data.key] = true;

    // The queue advances when this dialog starts to CLOSE, not when it is shown:
    // one dialog on screen at a time, and the next appears the moment this one
    // goes, without a blank gap in between.
    $modal.on('hide.bs.modal', function (e) {
      alerts.queue.shift();
      alerts.executeFromQueue();
    });

    $modal.on('hidden.bs.modal', function (e) {
      if(data.key) delete alerts.activeKeys[data.key];
      $modal.remove();
    });

    $modal.on('shown.bs.modal', function (e) {
      if(data.onShowCallback) {
        data.onShowCallback();
      }
    });

    // static backdrop is the template's default; keyboard: false is what stops esc
    $modal.modal(data.dismissible === false ? { backdrop: 'static', keyboard: false, show: true } : 'show');

    $modal.css('padding-right', 0);
    // A dialog taller than the screen must always be scrollable to its bottom.
    // Bootstrap gives .modal overflow-y only through body.modal-open — which it
    // removes when ANY modal closes (an app modal closing around an open alert
    // included) — so the container carries its own, independent of the rest.
    $modal.css('overflow-y', 'auto');
  }
};
